import doc                    from 'decorators/doc';
import model                  from 'decorators/model';
import { Timestampable }      from 'helpers/traits';
import { Blamable }           from 'helpers/traits';
import InvoicePrivateApiModel from 'modelx/models/abstracts/InvoicePrivateApiModel';

@model.staticLabel('Zone de taxe', false)
@model.urnResource('tax_zone')
@doc.path('/tax_zones/{?id}')
export default class TaxZoneModel extends Blamable(Timestampable(InvoicePrivateApiModel)) {
	public _filters: ModelFiltersExtended<{
		'code': id;
		'createdAt[after]': string;
		'createdAt[before]': string;
		'createdAt[strictly_after]': string;
		'createdAt[strictly_before]': string;
		'label': string;
		'exists[taxZoneCountries]': '0' | '1';
		'taxZoneCountries': id;
		'taxZoneCountries.country': string;
		'taxZoneTaxZoneScopes': id;
		'taxZoneTaxZoneScopes.taxZoneScope': id;
		'taxZoneTaxZoneScopes.taxZoneScope.reference': InvoiceTaxZoneScopeReference;
		'updatedAt[after]': string | Date;
		'updatedAt[before]': string | Date;
		'updatedAt[strictly_after]': string | Date;
		'updatedAt[strictly_before]': string | Date;
	}> = {};

	public _sorts: ModelSortsExtended<{
		'id': string;
		'code': string;
		'label': string;
		'updatedAt': string;
	}> = {};

	@doc.string declare code: string;
	@doc.string declare label: string;
}